import css from 'styled-jsx/css';
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export const ImageSliderCSS = css`
  .section-device-slider {
    display: flex;
    flex-direction: row;
    margin: 1rem 0;
    width: 100%;
    .device-slider-instructions {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      overflow: hidden;
      clip-path: inset(50%);
      white-space: nowrap;
    }
    :global(.custom-link-image-slider:focus-visible),
    :global(.device-slider--slide--image-box--play-button:focus-visible),
    .device-slider-container:focus-visible {
      outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
      outline-offset: 2px;
    }
    & .column-images {
      display: none;
    }
    & .device-slider-container {
      position: relative;
      width: 100%;
      overflow: hidden;
      &--label {
        height: 2rem;
      }
      & .device-slider {
        display: flex;
        transition: transform 0.3s ease-in-out;
        height: 17.5rem;
        &--slide {
          position: relative;
          flex: 0 0 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &--stamp {
            display: flex;
            justify-content: center;
            width: 100%;
            margin-right: 2rem;
            //margin-bottom: 0.8rem;
          }
          &--image-box {
            display: flex;
            flex-grow: 1;
            width: 100%;
            align-items: center;
            justify-content: center;
            :global(.device-slider--slide--image-box--play-button) {
              .background{
                position: absolute;
                border-radius: 50%;
                background-color: #313235;
                height: 40px;
                width: 40px;
              }
              opacity: 0.9;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              z-index: 1;
            }
          }
        }
        & img {
          max-width: 100%;
          max-height: 100%;
          object-fit: cover;
          & .moving {
            transition: transform 0.3s ease-in-out;
          }
        }
      }
    }
    & .device-slider-counter {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
      &--bullet {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: #DDDDDD;
        margin: 0 0.25rem;
      }
      &--bullet-active {
        height: 12px;
        width: 12px;
        border-radius: 50%;
        background-color: ${getColor(COLOR_DICTIONARY.MOVISTAR_BLUE)};
        margin: 0 0.25rem;
      }
    }
  }

  /* Desktop */
  @media screen and (min-width: 768px) {
    :global(.custom-link-image-slider){
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    :global(.custom-link-image-slider:focus-visible){
        outline-style: auto;
        outline-offset: 5px;
    }
    .section-device-slider {
      height: 31rem;
      width: auto;
      & .column-images {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding-left: 2rem;
        width: 18rem;
        &--container {
          display: flex;
          justify-content: center;
          width: 60%;
          height: 20%;
          padding: 0.25rem;
          &--image-box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-grow: 1;
            width: 100%;
            &--play-button {
              .background{
                position: absolute;
                border-radius: 50%;
                background-color: #313235;
                height: 20px;
                width: 20px;
              }
              opacity: 0.8;
              height: 25px;
              width: 25px;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 1;
            }
          }
          &--stamp {
            display: flex;
            justify-content: center;
            width: 100%;
          }
          &--active {
            border-radius: 0.25rem;
            border: 1.6px solid ${getColor(COLOR_DICTIONARY.MOVISTAR_BLUE)};
          }
        }
      }
      & .device-slider-container {
        & .device-slider {
          height: 27rem;
          & img {
            height: 27rem;
          }
        }
      }
      & .device-slider-counter {
        visibility: hidden;
      }
    }
  }
`;
